// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4":"672b86e5","248":"e686bb77","878":"988a40db"}[chunkId] + ".chunk.css";
};